var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"experience margin-b-50"},[_c('ul',{staticClass:"list margin-b-30"},[_c('li',[_c('b',[_vm._v(_vm._s(_vm.item.title)+":")]),_vm._v(" "+_vm._s(_vm.item.list.join(', ')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d81ba64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subComponents/Hobbie.vue
// module id = null
// module chunks = 